module.exports = __webpack_public_path__ + "img/S9-3.2aea813f.png";